import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 px-4 relative bg-navy-950 overflow-hidden" data-id="element-226">
      {/* Subtle Atmosphere */}
      <div className="absolute inset-0 bg-flag-stripes opacity-30 pointer-events-none z-0" data-id="element-227"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-patriot-blue/10 blur-[100px] rounded-full pointer-events-none z-0" data-id="element-228"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-229">
        <div className="relative p-8 md:p-14 glass-card shadow-2xl rounded-2xl border-patriot-red/20 bg-navy-900/70 backdrop-blur-xl" data-id="element-230">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-12 h-12 border-t-4 border-l-4 border-patriot-red rounded-tl-2xl" data-id="element-231"></div>
          <div className="absolute top-0 right-0 w-12 h-12 border-t-4 border-r-4 border-patriot-red rounded-tr-2xl" data-id="element-232"></div>
          <div className="absolute bottom-0 left-0 w-12 h-12 border-b-4 border-l-4 border-patriot-red rounded-bl-2xl" data-id="element-233"></div>
          <div className="absolute bottom-0 right-0 w-12 h-12 border-b-4 border-r-4 border-patriot-red rounded-br-2xl" data-id="element-234"></div>

          <div className="flex items-start gap-8" data-id="element-235">
            <div className="space-y-6" data-id="element-236">
              <p className="text-xl md:text-2xl font-serif leading-relaxed text-slate-200" data-id="element-237">
                <span className="text-transparent bg-clip-text bg-red-gradient font-black text-7xl md:text-8xl float-left mr-5 leading-[0.8] mt-2 drop-shadow-md" data-id="element-238">
                  O
                </span>
                n September 10, 2025, the crack of a gunshot in a Utah
                auditorium wasn't just meant to silence one man; it was meant to
                amputate the tongue of an entire generation. In that instant,
                the debate ended and the resistance began. That bullet was no
                accident — it was the logical conclusion of years of
                dehumanization, censorship algorithms, and hatred cultivated in
                the shadows of power.
              </p>

              <p className="text-lg md:text-xl text-slate-400 leading-relaxed" data-id="element-239">
                If you've ever felt you had to measure your words at work, at
                university, or even in front of your own family to avoid being
                "canceled," you already know what it's like to live in the
                prelude to total silence.
              </p>

              <div className="mt-8 p-6 bg-patriot-red/10 border border-patriot-red/40 rounded-xl flex gap-5 items-start shadow-inner" data-id="element-240">
                <AlertTriangleIcon className="w-10 h-10 text-patriot-red flex-shrink-0" data-id="element-241" />
                <div data-id="element-242">
                  <h4 className="text-patriot-red font-black uppercase tracking-widest mb-2 text-sm" data-id="element-243">
                    Warning
                  </h4>
                  <p className="text-lg font-medium text-white" data-id="element-244">
                    This information has a shelf life. This book is not just a
                    story; it's the exclusive map so you never have to stay
                    silent. Read it before it disappears.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}